module.exports = __webpack_public_path__ + "static/media/logo-wide-light-bg.a0ffe3ae.png";